// import {parse,serialize} from 'cookie'
import Cookies from './js.cookie'

export function setCookie(name, value, option = {}){
	// document.cookie=serialize(...args);
	Cookies.set(name, value, option);
}

export function getCookie(key){
	// return (parse(document.cookie)||{})[key]
	return Cookies.get(key)
}

export function delCookie(key){
	// return (parse(document.cookie)||{})[key]
	return Cookies.remove(key)
}




//////////////////
// WEBPACK FOOTER
// ./scripts/utils/cookie.js
// module id = xZqY
// module chunks = 55